module.exports = __webpack_public_path__ + "media/images/workplace/banners/more_to_do/more_to_do_about_you_card-89bfd8ba246d0af3682edc8533b1b649.jpg";